/**
 * Frontend mirror of server/modules/invoicing/prepayment-balance.js
 */

function round2(n) {
  return Math.round(n * 100) / 100;
}

export function getPrepaymentReceived(prepayment) {
  if (!prepayment) return 0;
  const txs = prepayment.payment_transactions || [];
  // Prefer transactions when present (includes credit reverses after partial credit / reopen)
  if (txs.length > 0) {
    return txs.reduce((sum, t) => sum + (parseFloat(t.amount) || 0), 0);
  }
  if (prepayment.status === 'paid') {
    return parseFloat(prepayment.amount_total) || 0;
  }
  return 0;
}

export function getPrepaymentUsed(prepayment) {
  if (!prepayment) return 0;
  const amountBilled = parseFloat(prepayment.amountBilled) || 0;
  if (amountBilled > 0) return amountBilled;
  return prepayment.billed ? (parseFloat(prepayment.amount_total) || 0) : 0;
}

export function getPrepaymentAvailable(prepayment) {
  const received = getPrepaymentReceived(prepayment);
  const used = getPrepaymentUsed(prepayment);
  return Math.max(0, round2(received - used));
}
